var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client/react';
import { ManageProjectsMenuQueryDocument } from './query.gql';
export const useDocumentProjects = (documentId) => {
    const _a = useQuery(ManageProjectsMenuQueryDocument, {
        variables: { documentId },
    }), { data, previousData } = _a, rest = __rest(_a, ["data", "previousData"]);
    const { fileSystemProjects } = data || previousData || {};
    return Object.assign(Object.assign({}, rest), { documentProjects: fileSystemProjects || [] });
};
